var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ClientHeader',{attrs:{"title":"Cliente Nuevo"}}),_c('hr'),(_vm.products.length > 0)?[_c('ClientForm',{attrs:{"products":_vm.products,"client":_vm.client},on:{"onCreate":_vm.onCreate}})]:[_vm._v("\n    Loading..\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }